// import { apiSlice } from '../api/apiSlice'
// import 

import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const RETURN_BASE = "/return"; 
const buildUrl = (endpoint) => RETURN_BASE + endpoint;

const returnsApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReturns: builder.query({ 
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Returns' }], 
            onQueryStarted: muiDataGridStarted.bind(null, 'getReturns', 'Returns') 
        }),
        getPortalReturnsWithoutShipmentsThatArePaid: builder.query({ 
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/payment-without-shipment?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Returns' }], 
            onQueryStarted: muiDataGridStarted.bind(null, 'getPortalReturnsWithoutShipmentsThatArePaid', 'PortalReturnsWithoutShipmentsThatArePaid') 
        }),
        bulkReturnShipmentsNewProfileReturn: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/create-shipments-with-profile`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'PortalReturnsWithoutShipmentsThatArePaid'},
                { type: 'Returns' },
            ],
        }),
        bulkRetryShipmentForReturn: builder.mutation({
            query: ({ returnIds, free }) => ({
                url: buildUrl(`/retry-shipment`),
                method: 'POST',
                body: { returnIds, free },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'PortalReturnsWithoutShipmentsThatArePaid'},
                { type: 'Returns' },
            ],
        }),
        bulkDeleteFailedReturns: builder.mutation({
            query: ({ returnIds, free }) => ({
                url: buildUrl(`/bulk-delete`),
                method: 'POST',
                body: { returnIds, free },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'PortalReturnsWithoutShipmentsThatArePaid'},
                { type: 'Returns' },
            ],
        }),

        getReturnLines: builder.query({ 
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/returnlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, args) => [{ type: 'ReturnLines', id: args.id }], 
            onQueryStarted: muiDataGridStarted.bind(null, 'getReturnLines', 'ReturnLines') 
        }),
        getAllReturnLines: builder.query({ 
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/returnlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, args) => [{ type: 'ReturnLines'}], 
            onQueryStarted: muiDataGridStarted.bind(null, 'getReturnLines', 'ReturnLines') 
        }),
        processReturnLinesBol: builder.mutation({ 
            query: linesData => ({
                url: buildUrl(`/returnlines/process`),
                method: 'POST',
                body: linesData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ReturnsSingle'},
                { type: "ReturnLines"}
            ],
        }),
        getReturnShipments: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/shipments`),
                method: 'GET'
            }),
            providesTags: () => [{ type: 'ReturnShipments' }],
        }),
        getReturn: builder.query({ 
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            // providesTags: (id) => [{ type: `Returns-${id}` }]
            providesTags: (result, error, id) => [{ type: 'ReturnsSingle'}]
        }),
        createReturn: builder.mutation({
            query: (retour) => ({
                url: buildUrl('/create'),
                method: 'POST',
                body: retour,
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrdersSingle' }],
        }),
        updateReturn: builder.mutation({
            query: returnObject => ({
                url: buildUrl(`/${returnObject.id}`),
                method: 'PUT',
                body: returnObject,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ReturnsSingle'},
                { type: "Returns"}
            ],
        }),
        completeReturn: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/complete`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ReturnsSingle'},
                { type: "Returns"},
                { type: "ReturnLines"}
            ],
        }),
        getReturnById: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
        }),
        deleteReturn: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
        }),
        getReturnReason: builder.query({
            query: (id) => ({
                url: buildUrl(`/reasons/${id}`),
                method: 'GET',
            }),
            providesTags: (id) => [{ type: `ReturnReasons`, id }]
        }),
        createReturnReason: builder.mutation({
            query: (reason) => ({
                url: buildUrl('/reasons/new'),
                method: 'POST',
                body: reason,
            }),
            invalidatesTags: () => [{ type: 'ReturnReasons' }]
        }),
        updateReturnReason: builder.mutation({
            query: ({ id, reason }) => ({
                url: buildUrl(`/reasons/${id}`),
                method: 'PUT',
                body: reason,
            }),
            invalidatesTags: () => [{ type: 'ReturnReasons' }]
        }),
        deleteReturnReason: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/reasons/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: () => [{ type: 'ReturnReasons' }]
        }),
        getReturnReasons: builder.query({
            query: (args) => ({
                url: buildUrl(`/reasons?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'ReturnReasons' }]
        }),
        getReturnReasonsSelect: builder.query({
            query: (body) => ({
                url: buildUrl(`/reasons?relationId=${body.relationId}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'ReturnReasonsSelect' }]
        }),
        bulkUpdateReturns: builder.mutation({
            query: ({ returnIds, state, rejectAll }) => ({
                url: buildUrl('/bulk-update'),
                method: 'PUT',
                body: {
                    returnIds,
                    ...(state && { state }),
                    ...(rejectAll && { rejectAll })
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Returns" },
                { type: 'ReturnsSingle'}
            ],
        }),
        exportReturns: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `returns_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { data: { success: true, message: jsonData.message, immediate: true } };
                        }

                        // Background processing (status 202)
                        return { data: { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId } };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `returns_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { data: { success: true, immediate: true } };
                },
            }),
        }),
        exportReturnLines: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/returnlines/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `retourregels_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { data: { success: true, message: jsonData.message, immediate: true } };
                        }

                        // Background processing (status 202)
                        return { data: { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId } };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `returns_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { data: { success: true, immediate: true } };
                },
            }),
        })
    })
});

export const {
    useGetReturnsQuery, 
    useGetAllReturnLinesQuery,
    useProcessReturnLinesBolMutation,
    useGetReturnLinesQuery, 
    useGetReturnQuery,
    useCreateReturnMutation,
    useUpdateReturnMutation,
    useCompleteReturnMutation,
    useGetReturnByIdQuery,
    useDeleteReturnMutation,
    useGetReturnReasonQuery,
    useCreateReturnReasonMutation,
    useUpdateReturnReasonMutation,
    useDeleteReturnReasonMutation,
    useGetReturnReasonsQuery,
    useGetReturnReasonsSelectQuery,
    useBulkUpdateReturnsMutation,
    useGetReturnShipmentsQuery,
    useExportReturnsMutation,
    useExportReturnLinesMutation,
    useGetPortalReturnsWithoutShipmentsThatArePaidQuery,
    useBulkRetryShipmentForReturnMutation,
    useBulkDeleteFailedReturnsMutation,
    useBulkReturnShipmentsNewProfileReturnMutation,
  } = returnsApiSlice;

